import ServiceRestApi from "./service-rest-api";

class UsersService {

    cachedResponse = {};

    getUserAffiliations = () => {
        return ServiceRestApi.get("/api/user-affiliations");
    }

    submitUserAdd = (data) => {
        return ServiceRestApi.post("/api/register", data);
    }


    submitUserUpdate = (data) => {
        return ServiceRestApi.patch("/api/user", data);
    }

    submitUserDelete = (data) => {
        return ServiceRestApi.post("/api/access-user", data);
    }

    getUsers = (date) => {
        return ServiceRestApi.get("/api/users");
    }
    getUser = (data) => {
        return ServiceRestApi.get("/api/user?user=" + data);
    }
    getStatus = () => {
        return ServiceRestApi.get("api/user-status");
    }
    getSources = () => {
        return ServiceRestApi.get("/api/sources");
    }
    getRoles = () => {
        return ServiceRestApi.get("api/roles");
    }

    login = (credentials) => {
        return ServiceRestApi.post("/login", credentials);
    }

    firstLogin = (credentials) => {
        return ServiceRestApi.patch("/password", credentials);
    }

    logout = ({ username, token }) => {
        return ServiceRestApi.get(`api/logout?username=${username}&Authorization=${token}`);
    }
    getAllStatus = () => {
        if (!this.cachedResponse['user-status-set']) {
            this.cachedResponse['user-status-set'] = ServiceRestApi.get(`/api/user-status`);
        }
        return this.cachedResponse['user-status-set'];
    }

    getCurrentStatus = (username) => {
        return ServiceRestApi.get(`/api/current-status?username=${username}`);
    }

    updateLastStatus = (username, status) => {
        return ServiceRestApi.patch(`/api/last-status?username=${username}&statusId=${status}`)
    }

    getLanguages = () => {
        return ServiceRestApi.get(`/api/languages/`);
    }

    forgotPSWD = (username) => {
        return ServiceRestApi.patch('forgot-password', username);
    }

    validateForgotPassword = (uuid) => {
        return ServiceRestApi.patch('validate-forgot-password', uuid);
    }

    changeForgotPassword = (credentials) => {
        return ServiceRestApi.patch('change-forgot-password', credentials);
    }

    changePassword = (credentials) => {
        return ServiceRestApi.post('api/reset-password', credentials);
    }

 
    /**
     * get agents username list
     * @returns Promise<HttpResponse>
     */
    getAgentsUsername = () => {
        return ServiceRestApi.get(`/api/agents-username`);
    }

}

export default new UsersService();